import { StaticImage } from 'gatsby-plugin-image';

type Props = {
    heading?: string;
    title1?: string;
    description1?: string;
    title2?: string;
    description2?: string;
};
const SutterReviewPlanOptions = ({
    heading,
    title1,
    description1,
    title2,
    description2,
}: Props) => {
    return (
        <section className="ehealth-info-boxes px-4 pt-8 pb-16 font-roboto">
            <div className="max-w-1200 mx-auto">
                <div className="text-28 leading-32 lg:leading-20 text-gray-accessible font-semibold pb-11 text-center ">
                    {heading}
                </div>
                <div className="md:grid grid-cols-2 gap-4 text-center">
                    <div className="bg-[#f6f6f6] px-5 pt-6 pb-12 mb-4 md:mb-0">
                        <div className="icon-image">
                            <StaticImage
                                width={88}
                                height={88}
                                src="./images/sutter-icon-search.png"
                                alt=""
                                loading="lazy"
                            />
                        </div>
                        <div className="carrier-info-txt">
                            <div className="text-20 font-bold mt-4 mb-5 text-gray-accessible">
                                {title1}
                            </div>
                            <div className="text-gray-accessible text-18">{description1}</div>
                        </div>
                    </div>
                    <div className="bg-[#f6f6f6] px-5 pt-6 pb-12">
                        <div className="icon-image">
                            <StaticImage
                                width={88}
                                height={88}
                                src="./images/sutter-icon-document.png"
                                alt=""
                                loading="lazy"
                            />
                        </div>
                        <div className="carrier-info-txt">
                            <div className="text-20 font-bold mt-4 mb-5 text-gray-accessible">
                                {title2}
                            </div>
                            <div className="text-gray-accessible text-18">{description2}</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SutterReviewPlanOptions;
